import type {ShowToastOpts} from '@Components/dismissible-toast/dismissible-toast.types';
import {renderElement} from '@Utils/root-element.util';
import {DismissibleToast} from '@Components/dismissible-toast/dismissible-toast';
import type {FeedbackToastProps} from '@Components/feedback-toast/feedback-toast';
import {FeedbackToast} from '@Components/feedback-toast/feedback-toast';
import {Provider} from 'react-redux';

window.PMW.mergePMW(PMW, {
  showToast: ({useMaxZIndex = false, ...toastProps}: ShowToastOpts) => {
    const toast = document.body.querySelector('.pmw-toast-container');

    if (toast) {
      toast.remove();
    }

    const container = document.createElement('div');
    container.classList.add('pmw-toast-container');
    container.classList.add('_position-fixed');
    if (useMaxZIndex) {
      container.classList.add('_z-index-max');
    }
    renderElement(container, <DismissibleToast {...toastProps} />);
    document.body.appendChild(container);
  },

  showFeedbackToast: (opts: FeedbackToastProps) => {
    const toast = document.body.querySelector('.pmw-feedback-toast-container');

    if (toast) {
      toast.remove();
    }

    const container = document.createElement('div');
    container.classList.add('pmw-feedback-toast-container');
    container.classList.add('_position-fixed');
    container.classList.add('_z-index-max');

    renderElement(
      container,
      <Provider store={window.PMW.redux.store}>
        <FeedbackToast {...opts} />
      </Provider>
    );

    document.body.appendChild(container);
  },
});
